<template>
    <b-container fluid class="bg-teal text-light mt-4 pt-3 d-print-none">
        <b-row>
            <b-col cols="12" offset-md="1" md="3">
                <h4>Member Organizations</h4>
                <ul class="list-unstyled">
                    <!-- Include organizations logos -->
                    <li v-for="memberOrganisation in memberOrganisations">
                        <p class="text-uppercase small pt-1 my-1 mx-2">
                            <img class="image my-1" :src="memberOrganisation.image" alt="" height="35" width="35">
                            <a :href="memberOrganisation.link" target="_blank" class="text-teal-200">{{memberOrganisation.name}}</a>
                        </p>
                    </li>
                    <!-- <li>
                        <p class="text-uppercase small pt-2 my-1 mx-2">
                            <img class="image my-1" src="/static/img/apacc.png" alt="" height="35" width="35">
                            <a href="http://www.apacc4hrd.org" target="_blank" class="text-teal-200">APACC</a>
                        </p>
                    </li>
                    <li>
                        <p class="text-uppercase small pt-2 my-1 mx-2">
                            <img class="image my-1" src="/static/img/apqn.png" alt="" height="35" width="35">
                            <a href="http://www.apqn.org" target="_blank" class="text-teal-200">APQN</a>
                        </p>
                    </li> -->
                </ul>
            </b-col>

            <b-col cols="12" md="4" class="text-left text-md-center">
                <h4>Contact Us</h4>
                <span class="footer-unstyled small" v-html="this.contactUs.value"></span>
            </b-col>
            <b-col cols="12" md="3" class="text-left text-md-right">
                <h4>Quick Links</h4>
                    <ul class="list-unstyled">
                        <li class="small" v-for="quickLink in this.quickLinks">
                            <a :href="quickLink.link" target="_blank" class="text-teal-200">{{quickLink.name}}</a>
                            <img class="image mt-1 ml-1" :src="quickLink.image" alt="" height="35" width="35">
                        </li>
                        <!-- <li class="small"><a href="http://moe.gov.mv" target="_blank" class="text-teal-200">Department of Higher Education</a><img class="image mt-1 ml-1" src="/static/img/dhe.png" alt="" height="35" width="35"></li>
                        <li class="small"><a href="http://moe.gov.mv" target="_blank" class="text-teal-200">Quality Assurance Department</a><img class="image mt-1 ml-1" src="/static/img/qad.png" alt="" height="35" width="35"></li>
                        <li class="small"><a href="http://moe.gov.mv" target="_blank" class="text-teal-200">TVETA</a><img class="image mt-1 ml-1" src="/static/img/tvet.png" alt="" height="35" width="35"></li>
                        <li class="small"><a href="http://moe.gov.mv" target="_blank" class="text-teal-200">NIE</a><img class="image mt-1 ml-1" src="/static/img/nie.png" alt="" height="35" width="35"></li> -->
                    </ul>
            </b-col>

        </b-row>
        <b-row class="bg-teal-700">
            <b-col cols="12">
                <p class="text-center pt-2 small">{{ currentYear }} © Maldives Qualification Authority. All Rights Reserved.</p>
            </b-col>
        </b-row>
    </b-container>
</template>
<script>
import axios from 'axios'
export default {
    data(){
        return{
            contactUs: [],
            memberOrganisations: [],
            quickLinks: []
        }
    },
    computed: {
        currentYear(){
            return (new Date()).getFullYear()
        }
    },
    methods: {
        getContactUs() {
            axios.get(this.API_URL + '/about/contact_us').then((response) => {
                this.contactUs = response.data
            }, (error) => {
                console.log(error)
            })
        },
        getQuickLinks() {
            axios.get(this.API_URL + '/quick_links').then((response) => {
                this.quickLinks = response.data
            }, (error) => {
                console.log(error)
            })
        },
        getMemberOrganisations() {
            axios.get(this.API_URL + '/member_organisations').then((response) => {
                this.memberOrganisations = response.data
            }, (error) => {
                console.log(error)
            })
        },
    },
    mounted() {
        this.getContactUs()
        this.getQuickLinks()
        this.getMemberOrganisations()
    }
}
</script>
<style scoped>
    img{
        border-radius: 50%;
    }
</style>



// WEBPACK FOOTER //
// src/components/SharedComponents/FooterPanel.vue